var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopPlaylist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#EECF93",
    fillOpacity: 0.33
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.735 24.6025H14.865C13.835 24.6025 13 25.4375 13 26.4675C13 27.4976 13.835 28.3325 14.865 28.3325H32.735C33.765 28.3325 34.6 27.4976 34.6 26.4675C34.6 25.4375 33.765 24.6025 32.735 24.6025Z",
    fill: "#EEAA25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.735 17H14.865C13.835 17 13 17.835 13 18.865C13 19.895 13.835 20.73 14.865 20.73H32.735C33.765 20.73 34.6 19.895 34.6 18.865C34.6 17.835 33.765 17 32.735 17Z",
    fill: "#EEAA25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.34 32.2046H14.865C13.835 32.2046 13 33.0396 13 34.0696C13 35.0996 13.835 35.9346 14.865 35.9346H26.34C27.37 35.9346 28.205 35.0996 28.205 34.0696C28.205 33.0396 27.37 32.2046 26.34 32.2046Z",
    fill: "#EEAA25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9085 17.1658C44.602 16.9764 44.2154 16.9474 43.8814 17.0884L38.1214 19.5227C37.7314 19.6875 37.48 20.0553 37.48 20.4611V33.3371C36.844 32.9863 36.1066 32.7844 35.32 32.7844C32.938 32.7844 31 34.6272 31 36.8922C31 39.1572 32.938 41 35.32 41C37.702 41 39.64 39.1572 39.64 36.8922V25.2362L44.7586 23.0731C45.1486 22.9083 45.4 22.5405 45.4 22.1347V18.0269C45.4 17.6793 45.2151 17.3552 44.9085 17.1658V17.1658Z",
    fill: "#EEAA25"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopPlaylist);
export default __webpack_public_path__ + "static/media/top_playlist.6c569b244045caa3577302109b4a7264.svg";
export { ForwardRef as ReactComponent };